import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetItemTreeDataStructure  {
    _originalTypeClassName = "zERP.BO.BudgetItemTreeDataStructure";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetItemTreeDataStructure.translate = translateService;
}
this.Tree = [];
this.Flat = [];
this.BudgetItemTreeDataStructureKey = null;
this._key = this.BudgetItemTreeDataStructureKey = 0; 
}

static translate: TranslateService;
_key: any;
Tree:any;
Flat:any;
private _BudgetItemTreeDataStructureKey:any;
get BudgetItemTreeDataStructureKey(): any {
    return this._BudgetItemTreeDataStructureKey;
  }
set BudgetItemTreeDataStructureKey(value: any) {
    this._BudgetItemTreeDataStructureKey = value;
    this._key = value;
  }
static setTree = ($this, items) => {
                if (items == null) items = [];
                if ($this.Tree == null) $this.Tree = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Tree.length > 0) {
                    Domain.BudgetItemTreeDataStructure.removeTree($this, $this.Tree[0]);
                }

                Domain.BudgetItemTreeDataStructure.addManyTree($this, copyItems);
            }
static addManyTree = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetItemTreeDataStructure.addTree($this, items[i]);
                }
            }
static addTree = ($this, item) => {
                if ($this.Tree == null) $this.Tree = [];
                if (item == null || $this.Tree.indexOf(item) > -1) return;
                $this.Tree.push(item);
}
static addRangeTree = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetItemTreeDataStructure.addTree($this, item));
            }
static removeTree = ($this, item) => {
                if ($this == null || $this.Tree == null || $this.Tree.indexOf(item) === -1) return;
                var _index = $this.Tree.indexOf(item);
                $this.Tree.splice(_index, 1);
}
static clearTree = ($this) => { $this.Tree = null; }
static setFlat = ($this, items) => {
                if (items == null) items = [];
                if ($this.Flat == null) $this.Flat = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Flat.length > 0) {
                    Domain.BudgetItemTreeDataStructure.removeFlat($this, $this.Flat[0]);
                }

                Domain.BudgetItemTreeDataStructure.addManyFlat($this, copyItems);
            }
static addManyFlat = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetItemTreeDataStructure.addFlat($this, items[i]);
                }
            }
static addFlat = ($this, item) => {
                if ($this.Flat == null) $this.Flat = [];
                if (item == null || $this.Flat.indexOf(item) > -1) return;
                $this.Flat.push(item);
}
static addRangeFlat = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetItemTreeDataStructure.addFlat($this, item));
            }
static removeFlat = ($this, item) => {
                if ($this == null || $this.Flat == null || $this.Flat.indexOf(item) === -1) return;
                var _index = $this.Flat.indexOf(item);
                $this.Flat.splice(_index, 1);
}
static clearFlat = ($this) => { $this.Flat = null; }

static GetBudgetItemTreeDataStructure(budgetItems: any,parent: any,budgetItemsFilter: any): any{let treeNodes = [];
let flatNodes = [];
if (!(CLMS.Framework.String.IsNullOrEmpty(budgetItemsFilter))) {budgetItemsFilter = budgetItemsFilter?.toUpperCase();}
for (let _ibudgetItem = 0; _ibudgetItem < (budgetItems == null ? 0 : budgetItems.length); _ibudgetItem++) {let budgetItem = budgetItems[_ibudgetItem];let node = new Domain.BudgetItemTreeListNode();node.budgetItemId = budgetItem?.Id;node.expanded = false;Domain.BudgetItemTreeListNode.setdata(node, new Domain.BudgetItemTreeListRowData());node.data.Name = budgetItem?.FullName;node.data.InitialAmount = 0;node.data.TemporaryAmount = 0;Domain.BudgetItemTreeListNode.setparent(node, parent);let childStructure = new Domain.BudgetItemTreeDataStructure();Domain.BudgetItemTreeDataStructure.setTree(childStructure, []);Domain.BudgetItemTreeDataStructure.setFlat(childStructure, []);if (budgetItem?.Children?.linq?.any()) {childStructure = Domain.BudgetItemTreeDataStructure.GetBudgetItemTreeDataStructure(budgetItem?.Children, node, budgetItemsFilter);if (!(CLMS.Framework.String.IsNullOrEmpty(budgetItemsFilter)) && CLMS.Framework.Number.LessThanOrEqual(() => childStructure.Tree.length, () => 0) && CLMS.Framework.Number.LessThan(() => budgetItem.FullName.toUpperCase().indexOf(budgetItemsFilter), () => 0)) {Domain.BudgetItemTreeListNode.setparent(node, null);continue;}node?.children?.addRange(childStructure?.Tree);flatNodes?.addRange(childStructure?.Flat);}if (!(CLMS.Framework.String.IsNullOrEmpty(budgetItemsFilter)) && CLMS.Framework.Number.LessThanOrEqual(() => childStructure.Tree.length, () => 0) && CLMS.Framework.Number.LessThan(() => budgetItem.FullName.toUpperCase().indexOf(budgetItemsFilter), () => 0)) {Domain.BudgetItemTreeListNode.setparent(node, null);continue;}treeNodes?.add(node);flatNodes?.add(node);}
let dataStructure = new Domain.BudgetItemTreeDataStructure();
Domain.BudgetItemTreeDataStructure.setTree(dataStructure, treeNodes?.linq?.orderBy((n) => n?.data?.Name)?.toArray());
Domain.BudgetItemTreeDataStructure.setFlat(dataStructure, flatNodes?.linq?.orderBy((n) => n?.data?.Name)?.toArray());
return dataStructure;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetItemTreeDataStructureKey == null || $this.BudgetItemTreeDataStructureKey == 0;
            }


}